// extracted by mini-css-extract-plugin
export default {"list":"InlineList_list_3E9FN"};